import { normalizeError } from "./errorNormalizer.es.js";
let messages = {};
const subscriptions = {
  messages: {},
  topics: {}
};
let postInterceptor = (message, topics) => message;
let onChange = () => {
};
let translate = (key) => key;
let log = (error) => {
  console.error(error);
  return void 0;
};
function setupMessages(options) {
  if (options.postInterceptor) {
    postInterceptor = options.postInterceptor;
  }
  if (options.translate) {
    translate = options.translate;
  }
  if (options.onChange) {
    onChange = options.onChange;
  }
  if (options.log) {
    log = options.log;
  }
}
function useMessages() {
  return {
    // Read
    getMessages: (key) => messages[key],
    getAllMessages: () => messages,
    subscribeMessage: (messageKey, callback) => registerSubscriber("messages", messageKey, callback),
    subscribeTopic: (topicKey, callback) => registerSubscriber("topics", topicKey, callback),
    unsubscribeTopic: (topicKey) => {
      unregisterSubscriber("topics", topicKey, 0);
    },
    // Posting
    postMessage: (key, message, topics = []) => {
      if (typeof message === "string") {
        message = {
          value: message
        };
      }
      post(key, message, normalizeTopics(topics));
    },
    postError: (key, errorMessage, topics = []) => {
      post(key, errorMessage, normalizeTopics(topics, ["error"]));
    },
    handleUnstructuredError: (prefix, error, topics = [], forceKey = null) => {
      const errorMessages = normalizeError(error, translate, log);
      const messages2 = Object.entries(errorMessages);
      messages2.forEach(([key, message]) => handleMessage(prefix, key, message, topics, forceKey));
    },
    // Clear
    clearMessages: () => {
      messages = {};
      onChange(messages);
    },
    deleteMessage: (key) => {
      var _a;
      delete messages[key];
      onChange(messages);
      const triggerCallback = (sub) => sub.callback(null, key, null);
      (_a = subscriptions["messages"][key]) == null ? void 0 : _a.forEach(triggerCallback);
    }
  };
}
function registerSubscriber(type, key, callback) {
  if (!subscriptions[type][key]) {
    subscriptions[type][key] = [];
  }
  const id = subscriptions[type][key].length;
  const unsubscribe = () => subscriptions[type][key].splice(id, 1);
  subscriptions[type][key].push({ id, callback, unsubscribe });
  return subscriptions[type][key][id];
}
function unregisterSubscriber(type, key, id) {
  if (subscriptions[type][key]) {
    subscriptions[type][key].splice(id, 1);
    if (subscriptions[type][key].length === 0) {
      delete subscriptions[type][key];
    }
  }
}
function hasSubscription(type, key) {
  return !!subscriptions[type][key];
}
function post(key, message, topics) {
  var _a;
  message.toString = function() {
    return this.value;
  };
  messages[key] = postInterceptor(message, topics);
  const triggerCallback = (sub) => sub.callback(message, key, topics);
  (_a = subscriptions["messages"][key]) == null ? void 0 : _a.forEach(triggerCallback);
  topics.forEach((topic) => {
    var _a2;
    return (_a2 = subscriptions["topics"][topic]) == null ? void 0 : _a2.forEach(triggerCallback);
  });
  onChange(messages);
}
function normalizeTopics(topics, topicsToAdd = []) {
  const formattedTopics = typeof topics === "string" ? [topics] : topics;
  topicsToAdd.forEach((topic) => {
    if (!formattedTopics.includes(topic)) {
      formattedTopics.push(topic);
    }
  });
  return formattedTopics;
}
function handleMessage(prefix, key, message, topics = [], forceKey) {
  const fullKey = forceKey ? forceKey : prefix ? `${prefix}.${key}` : key;
  if (!hasSubscription("messages", fullKey)) {
    topics = normalizeTopics(topics, prefix ? [prefix] : []);
  }
  if (!hasSubscription("topics", prefix || "")) {
    topics = normalizeTopics(topics, ["general"]);
  }
  post(fullKey, message, normalizeTopics(topics, ["error"]));
}
window.__messages = messages;
window.__messagesService = useMessages();
export {
  setupMessages,
  useMessages
};
//# sourceMappingURL=messages.service.es.js.map
